import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UploaderService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	sendFile(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/uploader', data)
			.map(res => res.json())
			.subscribe((response) => {
				this.data = response;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
